export const PREFORECLOSURES_KEY = 'preforeclosures' as const
export const PROPERTY_INFO_KEY = 'propertyInfo' as const
export const LAND_KEY = 'land' as const
export const TAXATION_KEY = 'taxation' as const
export const LIENS_AND_OWNERS_KEY = 'liens-and-owners' as const
export const MORE_TAB_KEY = 'more' as const
